'use client';

import type { CSSProperties } from 'react';

export function PublicMenuPoweredFooter({
  brandingLevel,
  visible,
  palette,
}: {
  brandingLevel: 'free' | 'none';
  visible: boolean;
  palette: {
    border: string;
    card: string;
    accent: string;
    accentForeground: string;
    foreground: string;
    mutedForeground: string;
  };
}) {
  if (brandingLevel === 'none' || !visible) {
    return null;
  }

  return (
    <footer className="border-t" style={{ borderColor: palette.border, backgroundColor: palette.card } as CSSProperties}>
      <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        {brandingLevel === 'free' ? (
          <div className="flex items-center gap-3">
            <div
              className="flex h-9 w-9 items-center justify-center rounded-full text-xs font-semibold"
              style={{ backgroundColor: palette.accent, color: palette.accentForeground }}
            >
              M
            </div>
            <div>
              <p className="text-sm font-semibold" style={{ color: palette.foreground }}>Menuraq</p>
              <p className="text-xs" style={{ color: palette.mutedForeground }}>Powered by Menuraq digital menus</p>
            </div>
          </div>
        ) : (
          <p className="text-xs font-medium uppercase tracking-[0.18em]" style={{ color: palette.mutedForeground }}>
            Powered by Menuraq
          </p>
        )}
        <a
          href="https://www.menuraq.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-semibold uppercase tracking-[0.14em]"
          style={{ color: palette.mutedForeground }}
        >
          menuraq.com
        </a>
      </div>
    </footer>
  );
}
